export const getSearchFilterFromSession = (pageId: string) => {
  const filterSessionData = JSON.parse(
    sessionStorage.getItem('globalSearch') || '{"selectedFilter": []}'
  )
  if (filterSessionData.pageId === pageId) {
    return filterSessionData.selectedFilter
  } else {
    return []
  }
}

type THEADERKeys = 'HEADER_INFLECTION' | 'AUTHORIZATION'

export interface IHEADER {
  [key: string]: any
}

export const HEADERS = () => {
  return {
    HEADER_INFLECTION: {
      'Key-Inflection': 'camel',
      'X-Change-Case': true
    },
    AUTHORIZATION: `Bearer ${getLocalStorage().token || ''}`,
    IS_JOURNEY_MODEL: `${getLocalStorage().isJourneyModel}`
  }
}

export const getLocalStorage = () => {
  return JSON.parse(localStorage.getItem('@Fareye:AuthToken') || '{}')
}

export function getUserType() {
  return getLocalStorage().userRole || 'child'
}

// export const getuser = () => ({
//   label: getLocalStorage().name,
//   value: getLocalStorage().email
// })

export const getOverrideUser = () => localStorage.getItem('jsonstore_user')

export const isJourneyModel = () => getLocalStorage().isJourneyModel as boolean

export const getUserModules = () => getLocalStorage().modules as string[]

let runtimeUserData: any = null

export const setRuntimeUserData = (user: any) => {
  runtimeUserData = user
}

export const getRuntimeUserData = () => {
  return runtimeUserData
}

export const clearRuntimeUserData = () => {
  runtimeUserData = null
}

export const getuser = () => ({
  label: getRuntimeUserData()?.name,
  value: getRuntimeUserData()?.email
})